import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map } from 'rxjs';
import { getAllRouteData } from '../lib/get-all-route-data';
import { getFullPath } from '../lib/get-full-path';
import { PICFLOW_STORYBLOK } from '../picflow-storyblok';

export const storyblokArticleStoryResolver = (route: ActivatedRouteSnapshot) => {
  const path = getAllRouteData(route).storyblokPathOverride || getFullPath(route).join('/') || 'home';
  const storyblokService = inject(PICFLOW_STORYBLOK);

  return storyblokService.getStory(path, route).pipe(map(resp => (resp && resp.story) || (false as const)));
};
